// extracted by mini-css-extract-plugin
module.exports = {"dynamicBanner":"da","bold":"ea"};